import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Shell from './Shell';
import { renderContent } from './routeContent';

export default function PortfolioManagerPage({ location, params }) {
  const safeParams = params || {};
  const content = useMemo(
    () => renderContent(location.pathname, safeParams),
    [location.pathname, safeParams],
  );

  return (
    <Shell location={location} params={safeParams}>
      {content}
    </Shell>
  );
}

PortfolioManagerPage.propTypes = {
  location: PropTypes.object.isRequired,
  params: PropTypes.object,
};
